module.exports = __webpack_public_path__ + "img/useFlow-small-bg3.952e08a.png";